const Operators = () => import('./_views/operators');

export default [
  {
    path: '/additional/operators',
    name: 'operators',
    component: Operators,
    meta: {
      title: 'Operators',
      group: 'additional',
      navigation: {
        position: 4,
        name: 'Operators',
        specialQueries: ['suffix'],
        to: {
          name: 'operators',
          query: {
            suffix: '',
            pageNum: '1',
          },
        },
      },
    },
  },
];
